import Studies from './Studies'

export default Studies
